import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './styles/App.css';
import Login from './components/Auth/Login';
import { RequireAdmin, HomeRedirect } from './components/Auth/RequireAdmin';
import Navbar from './components/Layout/Navbar';
import Sidebar from './components/Layout/Sidebar';
import Footer from './components/Layout/Footer';
import UserManagement from './components/Admin/UserManagement';
import DriverManagement from './components/Admin/DriverManagement';
import TruckManagement from './components/Admin/TruckManagement';
import ShipperManagement from './components/Admin/ShipperManagement';
import CarrierManagement from './components/Admin/CarrierManagement';
import ConsigneeManagement from './components/Admin/ConsigneeManagement';
import FreightManagement from './components/Admin/FreightManagement';
import FreightImport from './components/Admin/FreightImport';
import ManifestManagement from './components/Admin/ManifestManagement';
import ManifestTemplatesManagement from './components/Admin/ManifestTemplatesManagement';
import WarehouseRowsManagement from './components/Admin/WarehouseRowsManagement';
import WarehouseBinsManagement from './components/Admin/WarehouseBinsManagement';
import InventoryItemsManagement from './components/Admin/InventoryItemsManagement';
import LowStockAlerts from './components/Admin/LowStockAlerts';
import InventoryTransfersManagement from './components/Admin/InventoryTransfersManagement';
import HsCodesAdmin from './components/Admin/HsCodesAdmin';
import OpsConsole from './components/Admin/ops/OpsConsole';
import RoutePlannerList from './components/Admin/RoutePlannerList';
import RoutePlannerDetail from './components/Admin/RoutePlannerDetail';
import DepotsManagement from './components/Admin/DepotsManagement';
import DesignPreviewLayout from './components/DesignPreview/DesignPreviewLayout';
import DesignPreviewHub from './components/DesignPreview/DesignPreviewHub';
import FreightImportReviewPreview from './components/DesignPreview/FreightImportReviewPreview';
import ImportCompletePreview from './components/DesignPreview/ImportCompletePreview';
import RoutePlanPreview from './components/DesignPreview/RoutePlanPreview';

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    const userData = localStorage.getItem('user');
    if (token && userData) {
      setUser(JSON.parse(userData));
    }
    setLoading(false);
  }, []);

  const handleLogin = (userData, token) => {
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(userData));
    setUser(userData);
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(null);
  };

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  if (!user) {
    return <Login onLogin={handleLogin} />;
  }

  return (
    <Router>
      <Routes>
        <Route
          path="/design-preview/*"
          element={
            <RequireAdmin user={user}>
              <DesignPreviewLayout />
            </RequireAdmin>
          }
        >
          <Route index element={<DesignPreviewHub />} />
          <Route path="import-review" element={<FreightImportReviewPreview />} />
          <Route path="import-complete" element={<ImportCompletePreview />} />
          <Route path="route-plan" element={<RoutePlanPreview />} />
        </Route>
        <Route
          path="*"
          element={
            <div className="app">
              <Navbar user={user} onLogout={handleLogout} />
              <div className="app-container">
                <Sidebar user={user} />
                <main className="main-content">
                  <Routes>
                    <Route path="/" element={<HomeRedirect user={user} />} />
              <Route
                path="/users"
                element={
                  <RequireAdmin user={user}>
                    <UserManagement />
                  </RequireAdmin>
                }
              />
              <Route path="/drivers" element={<DriverManagement />} />
              <Route path="/trucks" element={<TruckManagement />} />
              <Route path="/shippers" element={<ShipperManagement />} />
              <Route path="/carriers" element={<CarrierManagement />} />
              <Route path="/consignees" element={<ConsigneeManagement />} />
              <Route path="/freight" element={<FreightManagement />} />
              <Route
                path="/freight/import"
                element={
                  <RequireAdmin user={user}>
                    <FreightImport />
                  </RequireAdmin>
                }
              />
              <Route path="/manifests" element={<ManifestManagement />} />
              <Route
                path="/manifest-templates"
                element={
                  <RequireAdmin user={user}>
                    <ManifestTemplatesManagement />
                  </RequireAdmin>
                }
              />
              <Route path="/warehouse-rows" element={<WarehouseRowsManagement />} />
              <Route path="/warehouse-bins" element={<WarehouseBinsManagement />} />
              <Route path="/inventory-items" element={<InventoryItemsManagement />} />
              <Route path="/inventory-low-stock" element={<LowStockAlerts />} />
              <Route
                path="/hs-codes"
                element={
                  <RequireAdmin user={user}>
                    <HsCodesAdmin />
                  </RequireAdmin>
                }
              />
              <Route
                path="/depots"
                element={
                  <RequireAdmin user={user}>
                    <DepotsManagement />
                  </RequireAdmin>
                }
              />
              <Route
                path="/route-planner"
                element={
                  <RequireAdmin user={user}>
                    <RoutePlannerList />
                  </RequireAdmin>
                }
              />
              <Route
                path="/route-planner/:id"
                element={
                  <RequireAdmin user={user}>
                    <RoutePlannerDetail />
                  </RequireAdmin>
                }
              />
              <Route
                path="/inventory-transfers"
                element={
                  <RequireAdmin user={user}>
                    <InventoryTransfersManagement />
                  </RequireAdmin>
                }
              />
              <Route
                path="/ops"
                element={
                  <RequireAdmin user={user}>
                    <OpsConsole />
                  </RequireAdmin>
                }
              />
                  </Routes>
                </main>
              </div>
              <Footer />
            </div>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;


